import React from 'react';

import { Card, Group, Image, Text, Title } from '@mantine/core';

import { LogoPaper, TitleText } from '@gtintel/vnext';

import classes from './AuthLayout.module.css';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className={classes.container}>
      <div className={classes.leftSection}>
        <div className={classes.loginBox}>
          <Image
            src="/assets/gti/logo-primary-dark.svg"
            alt="Ground Truth Intelligence"
            className={classes.mobileLogo}
            mb="xl"
          />

          {title && (
            <>
              <Title order={2} className={classes.loginTitle}>
                {title}
              </Title>
              {subtitle && (
                <Text ta="center" c="dimmed" fw={600} mb="md">
                  {subtitle}
                </Text>
              )}
            </>
          )}
          <Group gap="md" justify="center" align="center">
            <Card withBorder shadow="lg" radius="md" p="xl">
              {children}
            </Card>
          </Group>
        </div>
      </div>
      <div className={classes.rightSection}>
        <Image
          src="/assets/gti/home-hero-image.png"
          alt="Ground Truth Intelligence"
          className={classes.heroImage}
        />
        <div className={classes.rightContent}>
          <LogoPaper>
            <TitleText hasSubtitle={false} />
            <Text size="xl" c="dimmed" ta="center" mt="md" maw={750} mx="auto">
              Due Diligence for a changing world
            </Text>
          </LogoPaper>
        </div>
      </div>
    </div>
  );
};
